










import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";
import { inventoryCollection, statusesCollection } from "../db";
import * as firebase from "firebase/app";

@Component({})
export default class EquipmentStatusEdit extends Vue {
  @Getter statuses;

  @Prop({ required: true })
  public item: any;

  async change(status) {
    await inventoryCollection
      .doc(this.item.id)
      .update({ status: statusesCollection.doc(status.id) });
  }
}
